(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.FMTBuilderSession = factory();
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var KEY = 'fmt_builder_visit_v1';
  var LEGACY_KEYS = ['fmt_builder_v4', 'fmt_builder_v4_r2', 'fmt_builder_v4_project'];
  var MAX_IDLE_MS = 60 * 60 * 1000;
  function clone(value) { return value == null ? null : JSON.parse(JSON.stringify(value)); }
  function object(value) { return !!value && typeof value === 'object' && !Array.isArray(value); }
  function create(options) {
    options = options || {};
    var clock = options.now || Date.now;
    var storage = options.storage, legacy = options.legacyStorage;
    var record = null;
    function now() { return clock(); }
    function clearLegacy() {
      LEGACY_KEYS.forEach(function (key) { try { if (legacy) legacy.removeItem(key); } catch (_) {} });
    }
    function valid(value) {
      var time = now();
      return object(value) && value.version === 1 && /^fmt_[a-zA-Z0-9_-]{8,70}$/.test(value.projectId || '') &&
        Number.isSafeInteger(value.revision) && value.revision >= 0 &&
        Number.isSafeInteger(value.lastActivity) && value.lastActivity > 0 && value.lastActivity <= time &&
        time - value.lastActivity < MAX_IDLE_MS && object(value.state) && Array.isArray(value.state.formats);
    }
    function read() {
      var raw;
      try {
        if (!storage) return { unavailable: true };
        raw = storage.getItem(KEY);
        if (!raw) return { value: null };
      } catch (_) { return { unavailable: true }; }
      try {
        var value = raw.length <= 150000 ? JSON.parse(raw) : null;
        if (object(value) && value.revision === undefined) value.revision = 0;
        if (!valid(value)) throw new Error('Invalid or expired visit');
        if (!object(value.recoveryContext)) value.recoveryContext = null;
        return { value: value };
      } catch (_) { try { storage.removeItem(KEY); } catch (_) {} return { value: null }; }
    }
    function write() {
      if (!record) return;
      // Revision orders state writes made within the same millisecond, without
      // treating background rendering or email metadata as fresh activity.
      record.revision++;
      try { if (storage) storage.setItem(KEY, JSON.stringify(record)); } catch (_) {}
    }
    function fresh(state) {
      record = { version: 1, projectId: options.createId(), revision: 0, lastActivity: now(), state: clone(state || { formats: [] }), recoveryContext: null };
      write(); return snapshot(false);
    }
    function snapshot(restored) { return { projectId: record.projectId, state: clone(record.state), restored: restored, lastActivity: record.lastActivity }; }
    function load(explicitState) {
      clearLegacy();
      if (object(explicitState)) { var linked = fresh(explicitState); linked.restored = true; linked.fromLink = true; return linked; }
      var stored = read();
      if (stored.value) { record = stored.value; return snapshot(true); }
      return fresh();
    }
    function resume() {
      var stored = read();
      // A newer page in this tab may have saved updated selections. Prefer it;
      // preserve newer in-memory work if a quota error prevented its last write.
      if (stored.value && (!valid(record) || stored.value.projectId !== record.projectId ||
          stored.value.lastActivity > record.lastActivity ||
          (stored.value.lastActivity === record.lastActivity && stored.value.revision >= record.revision))) {
        record = stored.value; return snapshot(true);
      }
      if (valid(record)) return snapshot(true);
      return fresh();
    }
    return {
      load: load,
      resume: resume,
      reset: function (state) { clearLegacy(); return fresh(state); },
      save: function (state) { if (!record) return; record.state = clone(state); write(); },
      touch: function (state) { if (!record) return; record.lastActivity = now(); if (state) record.state = clone(state); write(); },
      getRecoveryContext: function () { return record ? clone(record.recoveryContext) : null; },
      saveRecoveryContext: function (context) { if (!record) return; record.recoveryContext = object(context) ? clone(context) : null; write(); },
      getProjectId: function () { return record && record.projectId; }
    };
  }
  return { create: create, key: KEY, maxIdleMs: MAX_IDLE_MS, legacyKeys: LEGACY_KEYS.slice() };
}));
